module.exports = __webpack_public_path__ + "d45a9267105016069a7ac5ecf06a7d68.svg";